var _defs, _g, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1200pt",
    height: "1200pt",
    viewBox: "0 0 1200 1200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m319 222.14h562v755.71h-562z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m356.9 222.14c-20.492 0-36.992 16.5-36.992 36.992v681.73c0 20.492 16.5 36.992 36.992 36.992h486.2c20.496 0 36.992-16.5 36.992-36.992l0.003906-681.73c0-20.492-16.5-36.992-36.992-36.992zm-5.2812 42.773h496.76v670.16h-496.76z",
    fill: "#01447a"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m433.53 468.66h332.94c6.5664 0 11.891 6.5664 11.891 11.891v11.891c0 6.5664-5.3242 11.891-11.891 11.891h-332.94c-6.5664 0-11.891-6.5664-11.891-11.891v-11.891c0-6.5664 5.3242-11.891 11.891-11.891z",
    fill: "#01447a"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m433.53 577.66h332.94c6.5664 0 11.891 6.5664 11.891 11.891v11.891c0 6.5664-5.3242 11.891-11.891 11.891h-332.94c-6.5664 0-11.891-6.5664-11.891-11.891v-11.891c0-6.5664 5.3242-11.891 11.891-11.891z",
    fill: "#01447a"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m433.53 686.66h332.94c6.5664 0 11.891 6.5664 11.891 11.891v11.891c0 6.5664-5.3242 11.891-11.891 11.891h-332.94c-6.5664 0-11.891-6.5664-11.891-11.891v-11.891c0-6.5664 5.3242-11.891 11.891-11.891z",
    fill: "#01447a"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m586.79 795.65h179.68c6.5664 0 11.891 6.5664 11.891 11.891v11.891c0 6.5664-5.3242 11.891-11.891 11.891h-179.68c-6.5664 0-11.891-6.5664-11.891-11.891v-11.891c0-6.5664 5.3242-11.891 11.891-11.891z",
    fill: "#01447a"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m419.62 223.33v178.84l55.062-55.062 56.109 56.105v-179.88z",
    fill: "#01447a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.3a84765fab3f2e8307b599a93098d3a5.svg";
export { ForwardRef as ReactComponent };